import { useEffect, useState } from 'react';
import { useFieldBase } from './useField';
export function useCurrencyField(props) {
    // for local field validation
    const [value, setValue] = useState(null);
    // get base props of validation fields
    const [{ value: state, ...baseProps }, saveState] = useFieldBase(props);
    // grab value changes from global state
    useEffect(() => {
        if (state !== undefined)
            setValue(state);
    }, [state, setValue]);
    return {
        ...baseProps,
        onBlur: (value) => saveState(value ?? undefined), // FIXME: this is not right
        onChange: (value) => setValue(value),
        value: value ?? null,
    };
}
// TODO: for backwards compatibility, can be removed once all hooks are renamed
export const useValidationCurrencyField = useCurrencyField;
